// import back1 from '../assets/icon/s_filters/back1.svg'
// import back2 from '../assets/icon/s_filters/back2.svg'
// import back3 from '../assets/icon/s_filters/back3.svg'
// import back4 from '../assets/icon/s_filters/back4.svg'

// import lapel1 from '../assets/icon/s_filters/lapel1.svg'
// import lapel2 from '../assets/icon/s_filters/lapel2.svg'
// import lapel3 from '../assets/icon/s_filters/lapel3.svg'
// import lapel4 from '../assets/icon/s_filters/lapel4.svg'

// import style1 from '../assets/icon/s_filters/style1.svg'
// import style2 from '../assets/icon/s_filters/style2.svg'
// import style3 from '../assets/icon/s_filters/style3.svg'

// import pocket1 from '../assets/icon/s_filters/pocket1.svg'
// import pocket2 from '../assets/icon/s_filters/pocket2.svg'
// import pocket3 from '../assets/icon/s_filters/pocket3.svg'

// import fabricImg from '../assets/selectF.jpg'

// import coat from '../assets/samples/coat/red_coat.png'
// import Shirt from '../assets/samples/shirt/grey_shirt.png'
// import pant from '../assets/samples/pant/red_pant.png'
// import vest from '../assets/samples/jacket/green_jacket.png'

// import green_coat_single from '../assets/samples/coat/g1_coat_single.png'
// import red_coat_single from '../assets/samples/coat/red_coat_single.png'
// import red_coat_back from '../assets/samples/coat/red_coat_back.png'
// import green_coat_back from '../assets/samples/coat/green_coat_back.png'

// import red_jacket from '../assets/samples/jacket/red_jacket_single.png'
// import green_jacket from '../assets/samples/jacket/green_jacket_single.png'

// import grey_shirt from '../assets/samples/shirt/grey_shirt_single.png'
// import pink_shirt from '../assets/samples/shirt/pink_shirt_single.png'

// import black_pant from '../assets/samples/pant/black_pant_single.png'
// import green_pant from '../assets/samples/pant/green_pant_single.png'

// import gcoat from '../assets/samples/coat/green_coat.png'
// import pShirt from '../assets/samples/shirt/orange_shirt.png'
// import gpant from '../assets/samples/pant/green_pant.png'
// import vest1 from '../assets/samples/jacket/red_jacket.png'

import sChart_in from "../assets/measurments/SC_IN.png";
import sChart_cm from "../assets/measurments/SC_CM.png";


// import {ReactComponent as one_button } from '../assets/SVG/SINGLE BUTTON-01.svg'
import one_button from "../assets/SVG/SINGLE BUTTON-01.svg";
import two_button from "../assets/SVG/double button-01.svg";
import three_button from "../assets/SVG/three button-01.svg";
import four_button from "../assets/SVG/four button-01.svg";
import six_button from "../assets/SVG/six button-01.svg";

import one_button_tux from "../assets/SVG/SVG_COAT/SINGLE BUTTON TUX.svg";
import two_button_tux from "../assets/SVG/SVG_COAT/double button TUX.svg";
import three_button_tux from "../assets/SVG/SVG_COAT/three button TUX.svg";
import four_button_tux from "../assets/SVG/SVG_COAT/four button TUX.svg";
import six_button_tux from "../assets/SVG/SVG_COAT/SIX button TUX.svg";

import j_round from "../assets/SVG/ROUND-01.svg";
import j_semiround from "../assets/SVG/semi round-01.svg";
import j_straight from "../assets/SVG/STRAIGHT-01.svg";
import j_open from '../assets/SVG/OPEN JODHPURI-01.svg'

import Notch from "../assets/SVG/Notch.svg";
import peak from "../assets/SVG/PEAK.svg";
import saul from '../assets/SVG/SVG_COAT/SHAWL LAPLE-01.svg'

import flap from "../assets/SVG/FLAP.svg";
import patch from "../assets/SVG/PATCH.svg";
import wallet from "../assets/SVG/SVG_COAT/WALLET-01.svg"

import upper_pocket_patch from '../assets/SVG/SVG_COAT/PATCH UPPER-01.svg'

import no_stitch from '../assets/SVG/NO TOP STITCH-01.svg'
import stitch from '../assets/SVG/TOP STITCH-01.svg'

import non_vent from "../assets/SVG/NON VENT.svg";
import s_vent from "../assets/SVG/SINGLE VENT.svg";
import side_vent from "../assets/SVG/SIDE VENT.svg";

import non_plates from "../assets/SVG/NON PLATES.svg";
import s_plates from "../assets/SVG/SINGLE PLATE.svg";
import d_plates from "../assets/SVG/DOUBLE PLATES.svg";

import back_pocket from "../assets/SVG/SINGLE POCKET.svg";
import d_pocket from "../assets/SVG/DOUBLE POCKET.svg";

import s_brested from "../assets/SVG/SINGLE BRESTED.svg";
import d_brested from "../assets/SVG/DOUBLE BRESTED.svg";

import semi_spread from "../assets/SVG/SEMI SPREAD.svg";
import spread from "../assets/SVG/SPREAD.svg";

import semi_spread_n from "../assets/SVG/SPREAD_n.svg";

import button_down from "../assets/SVG/BUTTON DOWN.svg";

import round_collar from '../assets/SVG/SVG_SHIRT/round collar-01.svg'

import mand from "../assets/SVG/MANDARIN.svg";

import square from "../assets/SVG/SQUARE.svg";
import ROUND from "../assets/SVG/ROUND.svg";
import NOTCH from "../assets/SVG/NOTCH 1.svg";

import square2 from "../assets/SVG/2SQUARE.svg";
import ROUND2 from "../assets/SVG/2ROUND.svg";
import NOTCH2 from "../assets/SVG/2NOTCH.svg";

import CUFFLINKS from "../assets/SVG/CUFFLINKS.svg";

import shirt_pocket_no from "../assets/SVG/NO POCKET.svg";
import shirt_pocket_1 from "../assets/SVG/POCKET.svg";

import shirt_side_cut from '../assets/SVG/SVG_SHIRT/SIDE CUT.svg'
import shirt_apple_cut from '../assets/SVG/SVG_SHIRT/APPLE CUT.svg'
import shirt_straight_cut from '../assets/SVG/SVG_SHIRT/STRAIGHT.svg'

import shirt_full_sleeve from '../assets/SVG/SVG_SHIRT/FULL SLEEVE.svg'
import shirt_half_sleeve from '../assets/SVG/SVG_SHIRT/HALF SLEEVE.svg'

import P1 from "../assets/suits/product-1.jpg";
import P2 from "../assets/suits/uniform.jpg";
import P3 from "../assets/suits/pant_shirt.jpg";

///// Kurta SVGs

import kurta_1POCKET from '../assets/SVG/SVG_KURTA/1 POCKET-01.svg'
import kurta_2FLAP from '../assets/SVG/SVG_KURTA/2 FLAP-01.svg'
import kurta_2POCKET from '../assets/SVG/SVG_KURTA/2 POCKET-01.svg'
import kurta_BOTTOCUTROUND from '../assets/SVG/SVG_KURTA/BOTTO CUT ROUND-01.svg'
import kurta_BOTTOMCUTSQURE from '../assets/SVG/SVG_KURTA/BOTTOM CUT SQURE-01.svg'
import kurta_BUTTONDOWNCOLLAR from '../assets/SVG/SVG_KURTA/BUTTON DOWN COLLAR-01.svg'
import kurta_BUTTONHIDE from '../assets/SVG/SVG_KURTA/BUTTON HIDE-01.svg'
import kurta_BUTTONSHOW from '../assets/SVG/SVG_KURTA/BUTTON SHOW-01.svg'
import kurta_BUTTON from '../assets/SVG/SVG_KURTA/BUTTON-01.svg'
import kurta_CHINACOLLAR from '../assets/SVG/SVG_KURTA/CHINA COLLAR-01.svg'
import kurta_CUFFSLEEVE from '../assets/SVG/SVG_KURTA/CUFF SLEEVE-01.svg'
import kurta_MANDARINCOLLAR from '../assets/SVG/SVG_KURTA/MANDARIN COLLAR-01.svg'
import kurta_MOREBUTTON from '../assets/SVG/SVG_KURTA/MORE BUTTON-01.svg'
import kurta_NOFLAP from '../assets/SVG/SVG_KURTA/NO FLAP-01.svg'
import kurta_NOPOCKET from '../assets/SVG/SVG_KURTA/NO POCKET-01.svg'
import kurta_NOShoulderEpaulette from '../assets/SVG/SVG_KURTA/NO Shoulder Epaulette-01.svg'
import kurta_NONCUFFSLEEVE from '../assets/SVG/SVG_KURTA/NON CUFF SLEEVE-01.svg'
import kurta_NOTCHFLAP from '../assets/SVG/SVG_KURTA/NOTCH FLAP-01.svg'
import kurta_NOTCHPLACKET from '../assets/SVG/SVG_KURTA/NOTCH PLACKET-01.svg'
import kurta_NOTCHPOCKET from '../assets/SVG/SVG_KURTA/NOTCH POCKET-01.svg'
import kurta_ROUNDCOLLAR from '../assets/SVG/SVG_KURTA/ROUND COLLAR-01.svg'
import kurta_ROUNDFLAP from '../assets/SVG/SVG_KURTA/ROUND FLAP-01.svg'
import kurta_ROUNDNECK from '../assets/SVG/SVG_KURTA/ROUND NECK-01.svg'
import kurta_ROUNDPOCKET from '../assets/SVG/SVG_KURTA/ROUND POCKET-01.svg'
import kurta_SEMISPREAD from '../assets/SVG/SVG_KURTA/SEMI SPREAD-01.svg'
import kurta_ShoulderEpaulette from '../assets/SVG/SVG_KURTA/Shoulder Epaulette-01.svg'
import kurta_SPREADCOLLAR from '../assets/SVG/SVG_KURTA/SPREAD COLLAR-01.svg'
import kurta_SQUREFLAP from '../assets/SVG/SVG_KURTA/SQURE FLAP-01.svg'
import kurta_SQUREPLACKET from '../assets/SVG/SVG_KURTA/SQURE PLACKET-01.svg'
import kurta_SQUREPOCKET from '../assets/SVG/SVG_KURTA/SQURE POCKET-01.svg'
import kurta_STANDERDCOLLAR from '../assets/SVG/SVG_KURTA/STANDERD COLLAR-01.svg'

/// pajama SVGs 
import pajama_CHURIDAR from '../assets/SVG/SVG_PAJAMA/CHURIDAR-01.svg'
import pajama_DHOTI from '../assets/SVG/SVG_PAJAMA/DHOTI-01.svg'
import pajama_PAJAMA from '../assets/SVG/SVG_PAJAMA/PAJAMA-01.svg'
import pajama_PANTPAJAMA from '../assets/SVG/SVG_PAJAMA/PANT PAJAMA-01.svg'
import pajama_SALWAR from '../assets/SVG/SVG_PAJAMA/SALWAR-01.svg'

import pajama_elastic from '../assets/SVG/SVG_PAJAMA/elastic-01.svg'
import pajama_rope from '../assets/SVG/SVG_PAJAMA/rope-01.svg'

/// Sadri SVGs
import sadri_BUTTON from '../assets/SVG/SVG_SADRI/BUTTON-01.svg'
import sadri_EMBROIDERY from '../assets/SVG/SVG_SADRI/EMBROIDERY-01.svg'
import sadri_HANDEMBOIDERY from '../assets/SVG/SVG_SADRI/HAND EMBOIDERY-01.svg'
import sadri_MOREBUTTON from '../assets/SVG/SVG_SADRI/MORE BUTTON-01.svg'
import sadri_NOVPOCKET from '../assets/SVG/SVG_SADRI/NO V POCKET-01.svg'
import sadri_STYLE1 from '../assets/SVG/SVG_SADRI/STYLE 1-01.svg'
import sadri_STYLE2 from '../assets/SVG/SVG_SADRI/STYLE 2-01.svg'
import sadri_STYLE3 from '../assets/SVG/SVG_SADRI/STYLE 3.svg'
import sadri_STYLE4 from '../assets/SVG/SVG_SADRI/STYLE 4-01.svg'
import sadri_STYLE5 from '../assets/SVG/SVG_SADRI/STYLE 5-01.svg'
import sadri_STYLE6 from '../assets/SVG/SVG_SADRI/STYLE 6-01.svg'
import sadri_STYLE7 from '../assets/SVG/SVG_SADRI/STYLE 7-01.svg'
import sadri_STYLE8 from '../assets/SVG/SVG_SADRI/STYLE 8-01.svg'
import sadri_STYLE9 from '../assets/SVG/SVG_SADRI/STYLE 9-01.svg'
import sadri_VPOCKET from '../assets/SVG/SVG_SADRI/V  POCKET-01.svg'

// pant SVGs
import pant_CROSSPOCKET from '../assets/SVG/SVG_PANT/CROSS POCKET.svg'
import pant_CUTBELT from '../assets/SVG/SVG_PANT/CUT BELT.svg'
import pant_DOUBLEBONEX1 from '../assets/SVG/SVG_PANT/DOUBLE BONE X 1.svg'
import pant_DOUBLEBONEX2 from '../assets/SVG/SVG_PANT/DOUBLE BONE X 2.svg'
import pant_FLAPX1 from '../assets/SVG/SVG_PANT/FLAP X 1.svg'
import pant_FLAPX2 from '../assets/SVG/SVG_PANT/FLAP X 2.svg'
import pant_GURKHA from '../assets/SVG/SVG_PANT/GURKHA.svg'
import pant_HOOK from '../assets/SVG/SVG_PANT/HOOK.svg'
import pant_LONGBELT from '../assets/SVG/SVG_PANT/LONG BELT.svg'
import pant_NONPOCKET from '../assets/SVG/SVG_PANT/NON POCKET.svg'
import pant_ROUNDPOCKET from '../assets/SVG/SVG_PANT/ROUND POCKET.svg'
import pant_SINGLEBONEX1 from '../assets/SVG/SVG_PANT/SINGLE BONE X 1.svg'
import pant_SINGLEBONEX2 from '../assets/SVG/SVG_PANT/SINGLE BONE X 2.svg'

// default Body
import hands from '../assets/Body/OLD/half sleeve.webp'
import wrist from '../assets/Body/OLD/full sleeve.webp'
import formal_body from '../assets/Body/OLD/body.jpg'

import wrist1 from '../assets/Body/DARK/hand for full sleeve.webp'
import hands1 from '../assets/Body/DARK/hand for half sleeve.webp'
import formal_body1 from '../assets/Body/DARK/body.jpg'

import wrist2 from '../assets/Body/MAIN/hand for full sleeve.webp'
import hands2 from '../assets/Body/MAIN/hand for half sleeve.webp'
import formal_body2 from '../assets/Body/MAIN/BODY.jpg'

import new_body from '../assets/Body/new_suit_body.jpg'
import pant_body_new from '../assets/Body/body_for_pant.jpg'
import kurta_body from '../assets/Body/kurta_body.png'
//

export const sizeChart = {
  u: [36, 38, 40, 42, 44, 46, 48, 50, 52],
  l: [30, 32, 34, 36, 38, 40, 42, 44, 46],
  img: [sChart_cm, sChart_in],

};
export const fabrics = [
  { fabric: "Blue Wool", brand: "Raymond", price: "1199" },
  { fabric: "Black Wool", brand: "Raymond1", price: "1200" },
  { fabric: "Green Wool", brand: "Raymond2", price: "1199" },
  { fabric: "Red Wool", brand: "Raymond3", price: "1199" },
  { fabric: "Silk", brand: "Raymond4", price: "1199" },
  { fabric: "Cotton", brand: "Raymond5", price: "1199" },
  { fabric: "Synthetic", brand: "Raymond6", price: "1199" },
  { fabric: "Nylon", brand: "Raymond7", price: "1199" },
  { fabric: "Party", brand: "Raymond8", price: "1199" },
  { fabric: "Sample", brand: "Raymond9", price: "1199" },
];

export const Types = {
  suit: {
    Coat: 0, Shirt: 4, Pant: 1, Vest: 2,
    measurement: 2
  },
  pant: {
    Pant: 0,
    measurement: 1
  },
  shirt: {
    Shirt: 0,
    measurement: 0
  },
  formal: {
    Shirt: 1, Pant: 0,
    measurement: 2
  },
  blazer: {
    Coat: -2,
    measurement: 0
  },
  kurta: {
    Kurta: 1,
    Coat: 0,
    Pajama: 2,
    Sadri: 0,
    measurement: 2
  },
  sadri:{
    Sadri: 0,
    measurement: 0
  }
};

// export const dummyImg  = {
//     "suits":{
//         "Shirt":Shirt,
//         "Pant":gpant,
//     }
// }

// export const Fabrics_all = {
//     "Coat":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":coat, "fabricIMG":fabricImg, "single" : [red_coat_single, red_coat_back]
//         },
//         {"fabric": "Green Wool", "brand":"Ray1", "price":"1200"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         }
//     ],
//     "Pant":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":pant, "fabricIMG":fabricImg, "single" : [black_pant]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond1", "price":"1200"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         }
//     ],
//     "Shirt":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":Shirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond1", "price":"1200"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [pink_shirt]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         }
//     ],
//     "Vest":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond1", "price":"1200"
//             ,"src":vest1, "fabricIMG":fabricImg,  "single" : [red_jacket]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":vest1, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":vest1, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         }
//     ]
// }

export const fabricFilter = [
  {
    type: "Sort Price",
    q: 2,
  },
];

export const StylesFilter = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
        { name: "Three Button", img: three_button, value: "3B" },
      ],
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Single Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Single Button", img: one_button_tux, value: "T-1B" },
        { name: "Double Button", img: two_button_tux, value: "T-2B" },
        { name: "Three Button", img: three_button_tux, value: "T-3B" },
      ],
    ],
  },
  {
    type: "Double Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Four Button", img: four_button_tux, value: "T-4B" },
        { name: "Six Button", img: six_button_tux, value: "T-6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "SV" },
        { name: "Side Vent", img: side_vent, value: "DV" },
      ],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
        { name: "Saul", img: saul, value: "S" },
      ],
    ],
  },
  {
    type: "Bottom Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "F" },
        { name: "Patch", img: patch, value: "P" },
      ],
    ],
  },
  {
    type: "Upper Pocket",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Wallet", img: wallet, value: "W" },
        { name: "Patch", img: upper_pocket_patch, value: "P" },
      ],
    ],
  },
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Stitch", img: stitch, value: "N" },
        { name: "Stitch", img: no_stitch, value: "Y" },
      ],
    ],
  },
  {
    type: "",
    name: "Coat",
    place: "Button",
    pos: "F",
    standalone : true,
    attr: [
    ],
  },
  {
    type: "Style",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
        { name: "Double Plates", img: d_plates, value: "F-DP" },
      ],
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
      ],
      [
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },

  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" }
      ],
      [
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },

  {
    type: "Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
        { name: "Spread", img: spread, value: "S0" },
      ],
      [
        { name: "Button Down", img: button_down, value: "BD" },
        { name: "Mandarin", img: mand, value: "0" },
      ],
    ],
  },
  {
    type: "Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
        { name: "Notch", img: NOTCH, value: "N" },
      ],
      [
        { name: "2 Button Square", img: square2, value: "X" },
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Vest",
    pos: "F",
    n: 0,
    place: "Vest Coat",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "V1" },
        { name: "Vest 2", img: d_brested, value: "V2" },
        { name: "Vest 3", img: d_brested, value: "V3" },
      ],
    ],
  },
  {
    type: "Vest - Tuxedo",
    name: "Vest",
    pos: "F",
    n: 0,
    category : "tuxedo",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "T-V1" },
      ],
    ],
  },
];

export const StylesFilterMob  = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
      ],
      [
        { name: "Three Button", img: three_button, value: "3B" },
      ]
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Single Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Single Button", img: one_button_tux, value: "T-1B" },
        { name: "Double Button", img: two_button_tux, value: "T-2B" },
      ],
      [{ name: "Three Button", img: three_button_tux, value: "T-3B" },]
    ],
  },
  {
    type: "Double Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Four Button", img: four_button_tux, value: "T-4B" },
        { name: "Six Button", img: six_button_tux, value: "T-6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "SV" },
      ],
      [{ name: "Side Vent", img: side_vent, value: "DV" },]
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
      [{ name: "Saul", img: saul, value: "S" },]
    ],
  },
  {
    type: "Bottom Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "F" },
        { name: "Patch", img: patch, value: "P" },
      ],
    ],
  },
  {
    type: "Upper Pocket",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Wallet", img: wallet, value: "W" },
        { name: "Patch", img: upper_pocket_patch, value: "P" },
      ],
    ],
  },
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Stitch", img: stitch, value: "N" },
        { name: "Stitch", img: no_stitch, value: "Y" },
      ],
    ],
  },
  {
    type: "",
    name: "Coat",
    place: "Button",
    pos: "F",
    standalone : true,
    attr: [
    ],
  },
  {
    type: "Style",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
      ],
      [{ name: "Double Plates", img: d_plates, value: "F-DP" },]
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },
      ],
      [
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },

  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },
      ],
      [
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" },
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
      ],
      [
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },

  {
    type: "Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
      ],
      [
        { name: "Spread", img: spread, value: "S0" },
        { name: "Button Down", img: button_down, value: "BD" },
      ],
      [{ name: "Mandarin", img: mand, value: "0" },]
    ],
  },
  {
    type: "Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
      ],
      [
        { name: "Notch", img: NOTCH, value: "N" },
        { name: "2 Button Square", img: square2, value: "X" },
      ],
      [
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Vest",
    pos: "F",
    n: 0,
    place: "Vest Coat",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "V1" },
        { name: "Vest 2", img: d_brested, value: "V2" },
      ],
      [{ name: "Vest 3", img: d_brested, value: "V3" },]
    ],
  },
  {
    type: "Vest - Tuxedo",
    name: "Vest",
    pos: "F",
    n: 0,
    category : "tuxedo",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "T-V1" },
      ],
    ],
  },
];

///// only for formal

export const StylesFilter_formal = [
  {
    type: "Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
        { name: "Spread", img: spread, value: "S0" },
      ],
      [
        { name: "Button Down", img: button_down, value: "BD" },
        { name: "Round", img: round_collar, value: "R0" },
        { name: "Mandarin", img: mand, value: "0" },
      ],
    ],
  },
  {
    type: "Sleeve",
    name: "Shirt",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Full Sleevel", img: shirt_full_sleeve, value: "F" },
        { name: "Half Sleeve", img: shirt_half_sleeve, value: "H" },
      ],
    ],
  },
  {
    type: "Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
        { name: "Notch", img: NOTCH, value: "N" },
      ],
      [
        { name: "2 Button Square", img: square2, value: "X" },
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Shirt",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Side Cut", img: shirt_side_cut, value: "K" },
        { name: "Apple", img: shirt_apple_cut, value: "A" },
        { name: "Straight", img: shirt_straight_cut, value: "B" },
      ],
    ],
  },
  
  {
    type: "Style",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
        { name: "Double Plates", img: d_plates, value: "F-DP" },
      ],
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
      ],
      [
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },

  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" }
      ],
      [
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },


];

export const StylesFilterMob_formal = [
  {
    type: "Shirt Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
      ],
      [
        { name: "Spread", img: spread, value: "S0" },
        { name: "Button Down", img: button_down, value: "BD" },
      ],
      [{ name: "Round", img: round_collar, value: "R0" },
      { name: "Mandarin", img: mand, value: "0" }],
    ],
  },
  {
    type: "Shirt Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
      ],
      [
        { name: "Notch", img: NOTCH, value: "N" },
        { name: "2 Button Square", img: square2, value: "X" },
      ],
      [
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Shirt Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Shirt",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Side Cut", img: shirt_side_cut, value: "K" },
        { name: "Apple", img: shirt_apple_cut, value: "A" },
      ],
      [{ name: "Straight", img: shirt_straight_cut, value: "B" }]
    ],
  },
  {
    type: "Sleeve",
    name: "Shirt",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Full Sleevel", img: shirt_full_sleeve, value: "F" },
        { name: "Half Sleeve", img: shirt_half_sleeve, value: "H" },
      ],
    ],
  },
  {
    type: "Plates",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
      ],
      [{ name: "Double Plates", img: d_plates, value: "F-DP" }],
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },

      ],
      [
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },
  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },

      ],
      [
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" },
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
      ],
      [
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },

];

export const StylesFilter_kurta = [
    {
      type: "Single Brested",
      name: "Coat",
      pos: "F",
      n: 0,
      place: "Coat",
      attr: [
        [
          { name: "Single Button", img: one_button, value: "1B" },
          { name: "Double Button", img: two_button, value: "2B" }
        ],
      ],
    },
    {
      type: "Jodhpuri",
      name: "Coat",
      pos: "F",
      n: 0,
      attr: [
        [
          { name: "Semi Round", img: j_semiround, value: "JH" },
          { name: "Round", img: j_round, value: "JR" },
          { name: "Straight", img: j_straight, value: "JS" },
        ],
        [{ name: "Open Jodhpuri", img: j_open, value: "JA" }]
      ],
    },
    {
      type: "Back Style",
      name: "Coat",
      pos: "B",
      n: 0,
      attr: [
        [
          { name: "Non Vent", img: non_vent, value: "NV" },
          { name: "Single Vent", img: s_vent, value: "1V" },
          { name: "Side Vent", img: side_vent, value: "2V" },
        ],
      ],
    },
    {
      type: "Lapel",
      name: "Coat",
      pos: "F",
      n: 1,
      attr: [
        [
          { name: "Notch", img: Notch, value: "N" },
          { name: "Peak", img: peak, value: "P" },
        ],
      ],
    },
    {
      type: "Pocket",
      name: "Coat",
      pos: "F",
      n: 2,
      attr: [
        [
          { name: "Flap", img: flap, value: "FL" },
          { name: "Patch", img: patch, value: "PT" },
        ],
      ],
    },
  ///////////////////// coat end

  //////////////////// Kurta
  {
    type: "Bottom Cut",
    name: "Kurta",
    pos: "F",
    n: 0,
    place: "Kurta",
    attr: [
      [
        { name: "Round", img: kurta_BOTTOCUTROUND, value: "R" },
        { name: "Straight", img: kurta_BOTTOMCUTSQURE, value: "S" },
      ],
    ],
  },

  {
    type: "Length",
    name: "Kurta",
    pos: "F",
    n: 10,
    attr: [
      [
        { name: "Normal", img: kurta_BOTTOCUTROUND, value: "L" },
        { name: "Short", img: kurta_BOTTOMCUTSQURE, value: "S" },
      ],
      [
        { name: "Short Pathani", img: kurta_BOTTOMCUTSQURE, value: "P_S" },
        { name: "Short Square", img: kurta_BOTTOMCUTSQURE, value: "QS_S" },
      ],
    ],
  },

  {
    type: "Neck Placket",
    name: "Kurta",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: kurta_NOTCHPLACKET, value: "NS" },
        { name: "Square", img: kurta_SQUREPLACKET, value: "QS" },
      ],
      [
        { name: "Short Pathani", img: kurta_SQUREPLACKET, value: "QS_SP" },
        { name: "Short Kurta", img: kurta_NOTCHPLACKET, value: "NS_SK" },
      ]
    ],
  },

  {
    type: "Pocket",
    name: "Kurta",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "No Pocket", img: kurta_NOPOCKET, value: "00" },
        { name: "1 Pocket", img: kurta_1POCKET, value: "01" },
        { name: "2 Pocket", img: kurta_2POCKET, value: "11" },
      ]
    ],
  },

  {
    type: "Pocket Type",
    name: "Kurta",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDPOCKET, value: "R" },
        { name: "Notch", img: kurta_NOTCHPOCKET, value: "N" },
        { name: "Square", img: kurta_SQUREPOCKET, value: "S" },
      ]
    ],
  },

  {
    type: "Flap",
    name: "Kurta",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Flap", img: kurta_NOFLAP, value: "0" },
        { name: "Flap", img: kurta_2FLAP, value: "1" },
      ]
    ],
  },
  {
    type: "Flap Type",
    name: "Kurta",
    pos: "F",
    n: 5,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDFLAP, value: "R" },
        { name: "Notch", img: kurta_NOTCHFLAP, value: "N" },
        { name: "Square", img: kurta_SQUREFLAP, value: "S" },
      ]
    ],
  },

  {
    type: "Shoulder Epaulette",
    name: "Kurta",
    pos: "F",
    n: 6,
    attr: [
      [
        { name: "NO", img: kurta_NOShoulderEpaulette, value: "0" },
        { name: "YES", img: kurta_ShoulderEpaulette, value: "SE" }
      ]
    ],
  },

  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Chinese Collar",
    attr: [
      [
        { name: "Round", img: kurta_ROUNDNECK, value: "CA" },
        { name: "MANDARIN", img: kurta_MANDARINCOLLAR, value: "CM" },
        { name: "CHINESE COLLAR", img: kurta_CHINACOLLAR, value: "CC" },
      ]
    ]
  },
  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Shirt Collar",
    hdr: 1,
    attr: [

      [
        { name: "ROUND", img: kurta_ROUNDCOLLAR, value: "CR" },
        { name: "BUTTON DOWN", img: kurta_BUTTONDOWNCOLLAR, value: "CB" },
        { name: "STANDARD", img: kurta_STANDERDCOLLAR, value: "CT" },
      ],
      [
        { name: "SEMI SPREAD", img: kurta_SEMISPREAD, value: "CE" },
        { name: "SPREAD", img: kurta_SPREADCOLLAR, value: "CS" },
      ]
    ],
  },
  {
    type: "Sleeve",
    name: "Kurta",
    pos: "F",
    n: 8,
    attr: [
      [
        { name: "No Cuff", img: kurta_NONCUFFSLEEVE, value: "SN" },
        { name: "Cuff", img: kurta_CUFFSLEEVE, value: "SC" }
      ]
    ],
  },
  {
    type: "Cuff Style",
    name: "Kurta",
    pos: "F",
    n: 9,
    attr: [
      [
        { name: "Square", img: square, value: "US1" },
        { name: "Round", img: ROUND, value: "UR1" },
        { name: "Notch", img: NOTCH, value: "UN1" },
      ],
      [
        { name: "2 Square", img: square2, value: "US2" },
        { name: "2 Round", img: ROUND2, value: "UR2" },
        { name: "2 Notch", img: NOTCH2, value: "UN2" },
      ]
    ],

  },

  /////// Kurta end

  //// Pajama 

  {
    type: "Style",
    name: "Pajama",
    pos: "F",
    n: 0,
    place: "Pajama",
    attr: [
      [
        { name: "Pant", img: pajama_PANTPAJAMA, value: "PP" },
        { name: "Salwar", img: pajama_SALWAR, value: "PS" },
        { name: "Churidar", img: pajama_CHURIDAR, value: "PC" },
      ],
      [
        { name: "Pajama", img: pajama_PAJAMA, value: "PJ" },
        { name: "Dhoti", img: pajama_DHOTI, value: "PD" }
      ]
    ],

  },
  {
    type: "Belt",
    name: "Pajama",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Elastic", img: pajama_elastic, value: "E" },
        { name: "Rope", img: pajama_rope, value: "R" },
      ]
    ],

  },
  //// end of Pajama

  /// start Sadri
  {
    type: "Style",
    name: "Sadri",
    pos: "F",
    n: 0,
    place: "Sadri",
    attr: [
      [
        { name: "Style 5", img: sadri_STYLE1, value: "EE" },
        { name: "Style 6", img: sadri_STYLE2, value: "FF" },
        { name: "Style 4", img: sadri_STYLE3, value: "DD" },
      ],
      [
        { name: "Style 1", img: sadri_STYLE5, value: "AA" },
        { name: "Style 2", img: sadri_STYLE6, value: "BB" },
        { name: "Style 3", img: sadri_STYLE4, value: "CC" },
      ],
      [
        { name: "Style 7", img: sadri_STYLE9, value: "RR" },
        { name: "Style 8", img: sadri_STYLE8, value: "SR" },
        { name: "Style 9", img: sadri_STYLE7, value: "SS" },
      ]

    ],

  },
  {
    type: "Pocket",
    name: "Sadri",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: sadri_NOVPOCKET, value: "0" },
        { name: "Pocket", img: sadri_VPOCKET, value: "1" },
      ]

    ],
  },
]

export const StylesFilterMob_kurta = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" }
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
      [{ name: "Straight", img: j_straight, value: "JS" },
        { name: "Open Jodhpuri", img: j_open, value: "JA" },
      ]
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "1V" },
      ],
      [{ name: "Side Vent", img: side_vent, value: "2V" }]
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
    ],
  },
  {
    type: "Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "FL" },
        { name: "Patch", img: patch, value: "PT" },
      ],
    ],
  },
  ///////////////////// coat end

  //////////////////// Kurta
  {
    type: "Bottom Cut",
    name: "Kurta",
    pos: "F",
    n: 0,
    place: "Kurta",
    attr: [
      [
        { name: "Round", img: kurta_BOTTOCUTROUND, value: "R" },
        { name: "Straight", img: kurta_BOTTOMCUTSQURE, value: "S" },
      ],
    ],
  },

  {
    type: "Neck Placket",
    name: "Kurta",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: kurta_NOTCHPLACKET, value: "NS" },
        { name: "Square", img: kurta_SQUREPLACKET, value: "QS" },
      ]
    ],
  },

  {
    type: "Pocket",
    name: "Kurta",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "No Pocket", img: kurta_NOPOCKET, value: "00" },
        { name: "1 Pocket", img: kurta_1POCKET, value: "01" },
      ],
      [{ name: "2 Pocket", img: kurta_2POCKET, value: "11" },]
    ],
  },

  {
    type: "Pocket Type",
    name: "Kurta",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDPOCKET, value: "R" },
        { name: "Notch", img: kurta_NOTCHPOCKET, value: "N" },
      ],
      [{ name: "Square", img: kurta_SQUREPOCKET, value: "S" },]
    ],
  },

  {
    type: "Flap",
    name: "Kurta",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Flap", img: kurta_NOFLAP, value: "0" },
        { name: "Flap", img: kurta_2FLAP, value: "1" },
      ]
    ],
  },
  {
    type: "Flap Type",
    name: "Kurta",
    pos: "F",
    n: 5,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDFLAP, value: "R" },
        { name: "Notch", img: kurta_NOTCHFLAP, value: "N" },
      ],
      [{ name: "Square", img: kurta_SQUREFLAP, value: "S" },]
    ],
  },

  {
    type: "Shoulder Epaulette",
    name: "Kurta",
    pos: "F",
    n: 6,
    attr: [
      [
        { name: "NO", img: kurta_NOShoulderEpaulette, value: "0" },
        { name: "YES", img: kurta_ShoulderEpaulette, value: "SE" }
      ]
    ],
  },

  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Chinese Collar",
    attr: [
      [
        { name: "Round", img: kurta_ROUNDNECK, value: "CA" },
        { name: "MANDARIN", img: kurta_MANDARINCOLLAR, value: "CM" },
      ],
      [{ name: "CHINESE COLLAR", img: kurta_CHINACOLLAR, value: "CC" },]
    ]
  },
  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Shirt Collar",
    hdr: 1,
    attr: [

      [
        { name: "ROUND", img: kurta_ROUNDCOLLAR, value: "CR" },
        { name: "BUTTON DOWN", img: kurta_BUTTONDOWNCOLLAR, value: "CB" },
      ],
      [
        { name: "STANDARD", img: kurta_STANDERDCOLLAR, value: "CT" },
        { name: "SEMI SPREAD", img: kurta_SEMISPREAD, value: "CE" },
      ],
      [{ name: "SPREAD", img: kurta_SPREADCOLLAR, value: "CS" },]
    ],
  },
  {
    type: "Sleeve",
    name: "Kurta",
    pos: "F",
    n: 8,
    attr: [
      [
        { name: "No Cuff", img: kurta_NONCUFFSLEEVE, value: "SN" },
        { name: "Cuff", img: kurta_CUFFSLEEVE, value: "SC" }
      ]
    ],
  },
  {
    type: "Cuff Style",
    name: "Kurta",
    pos: "F",
    n: 9,
    attr: [
      [
        { name: "Square", img: square, value: "US1" },
        { name: "Round", img: ROUND, value: "UR1" },
        
      ],
      [
        { name: "Notch", img: NOTCH, value: "UN1" },
        { name: "2 Square", img: square2, value: "US2" },
      ],
      [
        { name: "2 Round", img: ROUND2, value: "UR2" },
        { name: "2 Notch", img: NOTCH2, value: "UN2" },
      ]
    ],

  },

  /////// Kurta end

  //// Pajama 

  {
    type: "Style",
    name: "Pajama",
    pos: "F",
    n: 0,
    place: "Pajama",
    attr: [
      [
        { name: "Pant", img: pajama_PANTPAJAMA, value: "PP" },
        { name: "Salwar", img: pajama_SALWAR, value: "PS" },
        
      ],
      [
        { name: "Churidar", img: pajama_CHURIDAR, value: "PC" },
        { name: "Pajama", img: pajama_PAJAMA, value: "PJ" },
      ],
      [{ name: "Dhoti", img: pajama_DHOTI, value: "PD" }]
    ],

  },
  {
    type: "Belt",
    name: "Pajama",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Elastic", img: pajama_elastic, value: "E" },
        { name: "Rope", img: pajama_rope, value: "R" },
      ]
    ],

  },
  //// end of Pajama

  /// start Sadri
  {
    type: "Style",
    name: "Sadri",
    pos: "F",
    n: 0,
    place: "Sadri",
    attr: [
      
        [
          { name: "Style 5", img: sadri_STYLE1, value: "EE" },
          { name: "Style 6", img: sadri_STYLE2, value: "FF" },
          
        ],
        [
          { name: "Style 4", img: sadri_STYLE3, value: "DD" },
          { name: "Style 1", img: sadri_STYLE5, value: "AA" },
        ],
        [
          { name: "Style 2", img: sadri_STYLE6, value: "BB" },
          { name: "Style 3", img: sadri_STYLE4, value: "CC" },
        ],
        [
          { name: "Style 7", img: sadri_STYLE9, value: "RR" },
          { name: "Style 8", img: sadri_STYLE8, value: "SR" },
        ],
        [
          { name: "Style 9", img: sadri_STYLE7, value: "SS" }
        ]
    ],

  },
  {
    type: "Pocket",
    name: "Sadri",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: sadri_NOVPOCKET, value: "0" },
        { name: "Pocket", img: sadri_VPOCKET, value: "1" },
      ]

    ],
  },

]

export const StylesFilter_Blazer = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
        { name: "Three Button", img: three_button, value: "3B" },
      ],
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
        { name: "Straight", img: j_straight, value: "JS" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "1V" },
        { name: "Side Vent", img: side_vent, value: "2V" },
      ],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
    ],
  },
  {
    type: "Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "FL" },
        { name: "Patch", img: patch, value: "PT" },
      ],
    ],
  },
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "No Stitch", img: stitch, value: "" },
        { name: "Stitch", img: no_stitch, value: "Y" },
      ],
    ],
  },
]

export const StylesFilterMob_Blazer = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
      ],

      [{ name: "Three Button", img: three_button, value: "3B" }],
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
      [{ name: "Straight", img: j_straight, value: "JS" }],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "1V" },
      ],
      [{ name: "Side Vent", img: side_vent, value: "2V" }],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
    ],
  },
  {
    type: "Coat Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "FL" },
        { name: "Patch", img: patch, value: "PT" },
      ],
    ],
  },
  ,
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "No Stitch", img: flap, value: "" },
        { name: "Stitch", img: patch, value: "Y" },
      ],
    ],
  },
]
export const defaultStyle = {
  Coat: {
    F: ["1B", "N", "FL"],
    B: ["NV"],
  },
  Pant: {
    F: ["F-NP"],
    B: ["B-SP"],
  },
  Vest: {
    F: ["SB"],
  },
  Shirt: {
    F: ["BASE", "0", "0", "C", "SLEEV"],
  },
};

export const PreFilter = [
  {
    name: "Clothing",
    items: [
      "Suits",
      "Shirt",
      "Uniform",
      "Vest",
      "Formal Wear",
      "Jodhpuri",
      "Blazer",
      "Kurtas",
      "Sharwani",
      "Pant",
    ],
  },
];

export const Sample_preset = [
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "11999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P1],
    price: "120",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "10999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P3],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P3],
    price: "8999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "7999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "6999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },

  {
    name: "atk Tux",
    image: [P1, P2],
    price: "11999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Formals",
    image: [P2, P1],
    price: "120",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Suede",
    image: [P3, P2],
    price: "10999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Tux",
    image: [P1, P3],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Formals",
    image: [P2, P3],
    price: "8999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Suede",
    image: [P3, P2],
    price: "7999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Tux",
    image: [P1, P2],
    price: "6999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Tux",
    image: [P1, P2],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "11999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P1],
    price: "120",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "10999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P3],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P3],
    price: "8999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "7999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "6999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
];

export const Body_config = {
    "formal": [
        {
            id : 0,
            body : formal_body2,
            hands : hands2,
            wrist : wrist2,
            property : "fair"
        },
        {
            id : 1,
            body : formal_body,
            hands : hands,
            wrist : wrist,
            property : "old"
        },
        {
            id : 2,
            body : formal_body1,
            hands : hands1,
            wrist : wrist1,
            property : "dark"
        },
    ],
    "shirt" :[
        {
            id : 0,
            body : formal_body2,
            hands : hands2,
            wrist : wrist2,
            property : "fair"
        },
        {
            id : 1,
            body : formal_body,
            hands : hands,
            wrist : wrist,
            property : "old"
        },
        {
            id : 2,
            body : formal_body1,
            hands : hands1,
            wrist : wrist1,
            property : "dark"
        },
    ],
    "suit" : [
      {
        id : 0,
        body : new_body,
        property : "fair"
      }
    ],
    "blazer" : [{
        id : 0,
        body : new_body,
        property : "fair"
    }],
    "kurta" : [{
        id : 0,
        body : kurta_body,
        property : "fair"
    }],
    "pant" : [{
        id : 0,
        body : pant_body_new,
        property : "fair"
    }]

}
